import React from "react";
import ManinNavComponent from "./mainNav";


export default function NavComponent ({type, clickRConsumer}){
    if (type === 'main'){
        return <ManinNavComponent clickRConsumer={clickRConsumer} />
    }
}